import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { MyAccountState, StateWithMyAccount } from '../my-account-state';
import { getMyAccountState } from './state.selectors';

export const revokeManager: MemoizedSelector<StateWithMyAccount, StateUtils.EntityLoaderState<string>> = createSelector(
  getMyAccountState,
  (state: MyAccountState) => state.revokeManager,
);

export const revokeManagerLoading = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(revokeManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entityLoadingSelector(state, personalManagerId),
  );

export const revokeManagerError = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(revokeManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entityErrorSelector(state, personalManagerId),
  );

export const revokeManagerSuccess = (personalManagerId: string): MemoizedSelector<StateWithMyAccount, boolean> =>
  createSelector(revokeManager, (state: StateUtils.EntityLoaderState<string>) =>
    StateUtils.entitySuccessSelector(state, personalManagerId),
  );
